import Parse from 'modules/parse'
import inDevelopment from 'modules/in-development'
import mqttDispatcher from 'modules/mqtt-dispatcher'
import parseObjectToJs from 'modules/parse-object-to-js'
import run from 'modules/run'
import runJob from 'modules/run-job'

export function getStatusOfAcademy ({user}, callback) {
  Parse.Cloud.run('getStatusOfAcademy', {user})
    .then(res => {
      callback(null, res)
    }, callback)
}

export function updateStatusOfAcademy ({user}, callback) {
  Parse.Cloud.run('updateStatusOfAcademy', {user})
    .then(res => {
      callback(null, res)
    }, callback)
}

export function queryChargebee (params, callback) {
  Parse.Cloud.run('queryChargebee', params)
    .then(res => {
      callback(null, res)
    }, callback)
}

export function getHarvests ({ groupId }, callback) {
  Parse.Cloud.run('getHarvests', { groupId })
    .then(res => callback(null, res))
    .catch(callback)
}

export function checkIfAdmin ({orgId, userId}, callback) {
  Parse.Cloud.run('determineIfAdminOfOrg', {orgId, userId})
    .then(res => {
      callback(null, res)
    }, callback)
}

export function sendInviteWithoutSFIDorRoles ({firstName, lastName, email, noRoles, organizationId}, callback) {
  Parse.Cloud.run('sendInviteWithoutSFIDorRoles', {firstName, lastName, email, noRoles, organizationId})
    .then(res => {
      callback(null, res)
    }, callback)
}

export function getUsersByRoleForFarmId (groupId, callback) {
  Parse.Cloud.run('getUsersByRoleForFarmId', {groupId})
    .then(res => {
      callback(null, res)
    }, callback)
}

export function removeUserFromFarmRole ({user, groupId}, callback) {
  Parse.Cloud.run('removeUserFromFarmRole', {user, groupId})
    .then(res => {
      callback(null, res)
    }, callback)
}

export function updateUserRoleByFarm ({user, updatedRole}, callback) {
  Parse.Cloud.run('updateUserRoleByFarm', {user, updatedRole})
    .then(res => {
      callback(null, res)
    }, callback)
}

export function getOrgUsersAndDetermineOrgAdmin ({orgId}, callback) {
  Parse.Cloud.run('getOrgUsersAndDetermineOrgAdmin', {orgId})
    .then(res => {
      callback(null, res.usersAndAdminStatus)
    }, callback)
}

export function removeUserFromOrganization ({userId, organizationId}, callback) {
  Parse.Cloud.run('removeUserFromOrganization', {userId, organizationId})
    .then(res => {
      callback(null, res)
    }, callback)
}

export function setAcademyDisplayStatus (params, callback) {
  Parse.Cloud.run('setAcademyDisplayStatus', params)
    .then(({ displayAcademy }) => {
      callback(null, displayAcademy)
    }, callback)
}

export function getLitmosUserAndPaidStatus ({ user }, callback) {
  user = user.data
  Parse.Cloud.run('litmosUserAndPaidStatus', { user })
    .then(({ paidStatus }) => {
      callback(null, paidStatus)
    }, callback)
}

export function getFarmcampRedirectUrl ({ user }, callback) {
  const litmosId = user.data.litmosId
  Parse.Cloud.run('farmcampRedirectUrl', { litmosId })
    .then(({ redirectUrl }) => {
      callback(null, redirectUrl)
    }, callback)
}

export function getOutputRunLogForFarm ({ farm, output }, callback) {
  Parse.Cloud.run('outputRunLogForFarm', {
    output,
    installationId: farm.farmInstallationId,
    objectId: farm.id || farm.objectId
  }, {
    success: function (data) {
      callback(null, data)
    },
    error: function (error) {
      callback(error, [])
    }
  })
}

export function setAgrowtekOutput ({ deviceId, message }, callback) {
  if (!deviceId) {
    callback('Must provide a deviceId')
    return
  }

  mqttDispatcher.publishControl({
    deviceId,
    message
  }, callback)
}

export function getFarmsForCurrentUser (callback) {
  const Farms = Parse.Object.extend('Farms')
  const query = new Parse.Query(Farms)
  // TODO: remove this once ACL is in place
  if (!inDevelopment) {
    query.containsAll('users', [Parse.User.current()])
  }
  query.find({
    success: function (results) {
      callback(null, results)
    },
    error: function (results, error) {
      console.log('Error:', JSON.stringify(error))
      callback(error, [])
    }
  })
}

export function getFarmById (farmId, callback) {
  const Farms = Parse.Object.extend('Farms')
  const query = new Parse.Query(Farms)
  query.include('hub')
  query.get(farmId, {
    success: function (farm) {
      callback(null, farm)
    },
    error: function (farm, error) {
      console.log('Error:', JSON.stringify(error))
      callback(error, {})
    }
  })
}

export function getImagesForFarm (farm, callback) {
  return getImagesForInstallationId(farm.farmInstallationId, callback)
}

export function getImagesForInstallationId (installationId, callback) {
  run('currentFarmImages', { installationId }, (error, data) => {
    if (error) {
      callback(error)
    } else {
      callback(null, data.map(transformImage))
    }
  })
}

export function getImagesForInstallationIdAtTimestamp ({ installationId, timestamp }, callback) {
  run('farmImagesForTimestamp', {
    installationId,
    timestamp
  }, (error, data) => {
    if (error) {
      callback(error)
    } else {
      callback(null, data.map(transformImage))
    }
  })
}

function transformImage (image) {
  return Object.assign({}, image, {
    url: image.imageFile.url()
  })
}

export function getAlertsForSensor ({ farmId, register }, callback) {
  run('alertsForSensor', {
    register,
    objectId: farmId
  }, callback)
}

export function saveAlertsForRegister ({ farmId, register, high, low, on }, callback) {
  run('saveAlertsForRegister', {
    farmId,
    register,
    high,
    low,
    on
  }, callback)
}

export function getOutputAlertsForFarm ({ farmId }, callback) {
  run('outputMonitorItemsForFarm', {
    farmId
  }, callback)
}

export function getGroupsForCurrentUser (callback) {
  run('GroupsForUser', callback)
}

export function getSimpleGroupListForCurrentUser (callback) {
  run('SimpleGroupListForUser', callback)
}

export function getGroupById (groupId, callback) {
  run('GroupById', {
    groupId
  }, (error, group) => {
    if (error) {
      callback(error)
    } else {
      callback(null, parseObjectToJs(group))
    }
  })
}

export function dataForArchComponent (componentId, callback) {
  run('dataForArchComponent', {
    componentId
  }, callback)
}

/* AWS */
export function currentFarmSensorReadings (installationId, callback) {
  run('currentFarmSensorReadings', {
    installationId
  }, callback)
}

export function currentFarmEquipmentState (installationId, callback) {
  run('currentFarmEquipmentState', {
    installationId
  }, callback)
}

export function currentFarmInputsState (installationId, callback) {
  run('currentFarmInputsState', {
    installationId
  }, callback)
}

export function sensorReadingsForTimePeriod (params, callback) {
  run('sensorReadingsForTimePeriod', {
    ...params,
    maxDataPoints: params.maxDataPoints || 500,
    registers: params.registers.join(',')
  }, callback)
}

export function equipmentReadingsForTimePeriod (params, callback) {
  run('equipmentReadingsForTimePeriod', {
    ...params,
    registers: params.registers.join(',')
  }, callback)
}

export function updateControllerName ({ installationId, name }, callback) {
  run('setControllerName', {
    installationId,
    name
  }, callback)
}

export function updateSensorLabel ({ installationId, name, register }, callback) {
  run('setSensorLabel', {
    installationId,
    register,
    name
  }, callback)
}

export function updateOutputLabel ({ installationId, name, register }, callback) {
  run('setControllerLabel', {
    installationId,
    register,
    name,
    label: 'outputs'
  }, callback)
}

export function updateInputLabel ({ installationId, name, register }, callback) {
  run('setControllerLabel', {
    installationId,
    register,
    name,
    label: 'inputs'
  }, callback)
}

export function updateZoneLabel ({ installationId, name, zoneId }, callback) {
  run('setZoneLabel', {
    installationId,
    zoneId,
    name
  }, callback)
}

export function equipmentLogForTimePeriod (params, callback) {
  run('equipmentLogForTimePeriod', {
    ...params,
    registers: params.registers.join(',')
  }, callback)
}

export function inputLogForTimePeriod (params, callback) {
  run('inputLogForTimePeriod', {
    ...params,
    registers: params.registers.join(',')
  }, callback)
}

export function saveSyncedControllerLabels (params, callback) {
  run('saveSyncedControllerLabels', params, callback)
}

export function acceptInvite (params, callback) {
  run('acceptInvite', params, callback)
}

export function updateCurrentUser (data, callback) {
  const user = Parse.User.current()

  user
    .save(data)
    .then((user) => {
      callback(null, user)
    }, callback)
}

export function getZendeskRedirectUrl (callback) {
  Parse.Cloud.run('zendeskRedirectUrl').then(({ redirectUrl }) => {
    callback(null, redirectUrl)
  }, callback)
}

export function enterHydroCalibrationMode (installationId, callback) {
  runJob('enterHydroCalibrationMode', {
    installationId
  }, callback)
}

export function leaveHydroCalibrationMode (installationId, callback) {
  runJob('leaveHydroCalibrationMode', {
    installationId
  }, callback)
}

export function calibrateEcZero ({ installationId, zones }, callback) {
  runJob('calibrateEcZero', {
    installationId,
    zones
  }, callback)
}

export function setCalibrationEcSpan ({ installationId, span, zones }, callback) {
  runJob('setCalibrationEcSpan', {
    installationId,
    span,
    zones
  }, callback)
}

export function calibratePhZero ({ installationId, zones }, callback) {
  runJob('calibratePhZero', {
    installationId,
    zones
  }, callback)
}

export function setCalibrationPhSpan ({ installationId, span, zones }, callback) {
  runJob('setCalibrationPhSpan', {
    installationId,
    span,
    zones
  }, callback)
}

export function calibrateSensorZero ({ installationId, sensor, zoneToOffset }, callback) {
  runJob('calibrateSensorZero', {
    installationId,
    sensor,
    zoneToOffset
  }, callback)
}

export function calibrateSensorSpan ({ installationId, sensor, zoneToSpan }, callback) {
  runJob('calibrateSensorSpan', {
    installationId,
    sensor,
    zoneToSpan
  }, callback)
}

export function clearPreviousCalibrations ({ installationId, zones, sensor }, callback) {
  runJob('clearPreviousCalibrations', {
    installationId,
    zones,
    sensor
  }, callback)
}

export function currentControllerSettings (installationId, callback) {
  run('currentControllerSettingsLookup', { installationId }, callback)
}

export function setNewControllerSetting (options, callback) {
  mqttDispatcher.publishConfiguration(options, callback)
}
export function currentControllerSettingsForOperation ({ installationId, operation }, callback) {
  run('currentControllerSettingsForType', { installationId, type: operation }, callback)
}

export function getCurrentRecipeForFarm (installationId, callback) {
  // TODO: HACK:
  // when we apply a recipe or update programming, we're invaliding/refetching the current
  // recipe. this endpoint will query dynamo for current programming. we're receiving word
  // of the new programming and outracing kinesis/lambda to the database, so we still see
  // out of date data. this artifical 2s delay "fixes" things by giving kinesis/lambda a
  // handicap.
  setTimeout(() => {
    run('getCurrentRecipeForFarm', { installationId }, (error, current) => {
      if (error) {
        callback(error)
      } else {
        callback(null, {
          ...current,
          recipe: current.recipe ? parseObjectToJs(current.recipe) : null
        })
      }
    })
  }, 2000)
}

export function getRecipeList (callback) {
  // TODO: should this be behind an endpoint?
  const query = new Parse.Query(Parse.Object.extend('FarmRecipe'))

  query
    .find()
    .then(recipes => {
      callback(null, recipes)
    }, callback)
}

export function applyRecipeToFarm ({ recipeId, installationId }, callback) {
  runJob('applyRecipeToFarm', { recipeId, installationId }, callback)
}

export function createRecipeFromControllerSettings ({ installationId, name, description }, callback) {
  run('createRecipeFromControllerSettings', ({ installationId, name, description }), callback)
}

export function connectivityLogForTimePeriod (params, callback) {
  run('connectivityLogForTimePeriod', params, callback)
}

export function connectivityLogForCharts (xStart, xEnd, connectivityData) {
  const initialConnectivityState = connectivityData.length > 0 ? {
    createdAt: new Date(xStart),
    sensorsOnline: !connectivityData[connectivityData.length - 1].sensorsOnline
  } : {
    createdAt: new Date(xStart),
    sensorsOnline: true
  }

  const finalConnectivityState = connectivityData.length > 0 ? {
    createdAt: new Date(xEnd),
    sensorsOnline: connectivityData[0].sensorsOnline
  } : {
    createdAt: new Date(xEnd),
    sensorsOnline: true
  }

  const completeConnectivityData = [finalConnectivityState].concat(connectivityData, [initialConnectivityState])

  return completeConnectivityData
}

export function timeLapsesForTimePeriod (params, callback) {
  run('timeLapsesForTimePeriod', params, callback)
}

export function getOrgStatus (orgId, callback) {
  Parse.Cloud.run('orgStatus', {orgId})
    .then(res => {
      callback(null, res)
    }, callback)
}

export function getOrgPrimaryAdmin (orgId) {
  return new Promise((resolve, reject) => {
    Parse.Cloud.run('getOrganizationPrimaryAdmin', { orgId })
      .then((res) => resolve(res.primaryAdmin))
      .catch(reject)
  })
}



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/modules/farmhand.js